/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_3_SrcInputs */

const en_cp_why_3_src = /** @type {(inputs: Cp_Why_3_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLR of 127 capstone studies (Tenhunen et al., 2023) & Bastarrica et al. (2026): client involvement decides outcomes.`)
};

const id_cp_why_3_src = /** @type {(inputs: Cp_Why_3_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLR 127 studi capstone (Tenhunen dkk., 2023) & Bastarrica dkk. (2026): keterlibatan klien menentukan hasil.`)
};

/**
* | output |
* | --- |
* | "SLR of 127 capstone studies (Tenhunen et al., 2023) & Bastarrica et al. (2026): client involvement decides outcomes." |
*
* @param {Cp_Why_3_SrcInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_3_src = /** @type {((inputs?: Cp_Why_3_SrcInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_3_SrcInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_3_src(inputs)
	return en_cp_why_3_src(inputs)
});